import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer.replace(/<[^>]*>/g, ''),
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-100">
      {/* FAQ Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">
            <i className="ri-questionnaire-line"></i>
            FAQ & Trust
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Alles, was du über OOPBuy Spreadsheet und das Shopping aus China wissen musst.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100/50 transition-colors"
              >
                <span className="font-medium text-sm md:text-base text-foreground-950 pr-4">
                  {item.question}
                </span>
                <span className="shrink-0 w-6 h-6 rounded-full bg-background-200/70 flex items-center justify-center">
                  <i
                    className={`ri-add-line text-foreground-600 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-45' : ''
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}